import React from "react";
import { Row, Col, Typography, Card, Input } from "antd";
import dayjs from "dayjs"
import { SelectInput, AntdButton, TextareaField, TimePickerField } from "../../../blueplanitUtils/InputField";
import { getOptionsByPath } from "../../../utilsdata";
import { USER_ISSUES, ISSUE_STATUS, TECH_STACK } from "../../../Dropdownmanager";
import { getEmployeesListThunk } from "../../../Slices/Thunk/getemployeelist";
import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";
 
const UserTaskEdit = ({ editingIssue, setEditingIssue, NestedDatabucket, handleUpdate, handleCancel }) => {
    const dispatch = useDispatch();
    //   const { list: employees } = useSelector((state) => state.employees);
    const employees = useSelector(
        (state) => state.employee.AllEmployees || []
    );
 
    //       useEffect(() => {
    //     if (!employees || employees.length === 0) {
    //         dispatch(getEmployeesListThunk());
    //     }
    // }, [dispatch, employees]);
 
    const getEmployeeName = (id) => {
        if (!id || !employees) return "—";
        const emp = employees.find((e) => e._id === id || e.id === id);
        return emp ? `${emp.firstname} ${emp.lastname}` : id;
    };
 
    if (!editingIssue) return null;
    const formatDateTime = (timestamp) => {
        return dayjs(Number(timestamp)).format("DD-MM-YYYY hh:mm A");
    };
 
 
    return (
        <div className="page-wrapper">
            <form onSubmit={handleUpdate}>
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginTop: -50,
                        marginBottom: 20,
                        paddingRight: 10,
                        paddingLeft: 20,
                    }}
                >
                    <div
                        style={{
                            position: "absolute",
                            top: -20,
                            right: 0,
                            display: "flex",
                            gap: "10px",
                        }}
                    >
 
                        <AntdButton
                            onClick={handleUpdate}
                            style={{
                                backgroundColor: "#007bff",
                                color: "white",
                                padding: "8px 16px",
                                border: "none",
                                borderRadius: "4px",
                                cursor: "pointer",
                            }}
                            label="Update"
                        />
 
                        <AntdButton
                            onClick={handleCancel}
                            style={{
                                backgroundColor: "#6c757d",
                                color: "#fff",
                                padding: "8px 16px",
                                border: "none",
                                borderRadius: "4px",
                                cursor: "pointer",
                            }}
                            label="Close"
                        />
                    </div>
                </div>
 
                <Card
                    style={{
                        marginLeft: 20,
                        marginRight: 40,
                        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                        borderRadius: "8px",
                    }}
                >
                    <h4> Task Information</h4>
                    <Row gutter={24}>
                        {/* LEFT COLUMN */}
                        <Col span={12}>
                            <Row gutter={[8, 8]}>
                                <Col span={8}>Task ID:</Col>
                                <Col span={16}>{editingIssue.TaskID || '—'}</Col>
 
                                <Col span={8}>Tab Name:</Col>
                                <Col span={16}>{editingIssue.Tabname || '—'}</Col>
 
                                <Col span={8}>Task Title:</Col>
                                <Col span={16}>{editingIssue.TaskTitle || '—'}</Col>
 
                                <Col span={8}>Priority:</Col>
                                <Col span={16}>{editingIssue.Priority || '—'}</Col>
 
                                <Col span={8}>Description:</Col>
                                <Col span={16}>{editingIssue.issuedescription || '—'}</Col>
 
 
                            </Row>
                        </Col>
 
                        {/* RIGHT COLUMN */}
                        <Col span={12}>
                            <Row gutter={[8, 8]}>
                                <Col span={8}>Deadline:</Col>
                                <Col span={16}>{editingIssue.Deadline || '—'}</Col>
 
                                <Col span={8}>Created Date & Time:</Col>
                                <Col span={16}>
                                    {editingIssue?.DateAndTime
                                        ? formatDateTime(editingIssue.DateAndTime)
                                        : "—"}
                                </Col>
                                <Col span={8}>Updated Date :</Col>
                                <Col span={16}>
                                    {editingIssue?.UpdatedDate
                                        ? formatDateTime(editingIssue.UpdatedDate)
                                        : "—"}
                                </Col>
 
 
                                <Col span={8}>Assigned To:</Col>
                                <Col span={16}>{Array.isArray(editingIssue.Assignedto)
                                    ? editingIssue.Assignedto.map(id => getEmployeeName(id)).join(", ")
                                    : getEmployeeName(editingIssue.Assignedto)}</Col>
 
                                <Col span={8}>Guide Notes:</Col>
                                <Col span={16}>{editingIssue.Instructions || '—'}</Col>
                            </Row>
                        </Col>
                    </Row>
                </Card>
                <Typography.Title level={5} style={{ marginBottom: -10, marginTop: 10, marginLeft: 40, flex: 1, textAlign: 'left', fontWeight: "bold" }}>Update Task</Typography.Title>
 
                <Card
                    style={{
                        marginLeft: 20,
                        marginTop: 20,
                        marginRight: 40,
                        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                        borderRadius: "8px",
                    }}
                >
                    <Row gutter={[8, 8]}>
                        <Col span={8}>
                            <SelectInput
                                label="Task Status"
                                value={editingIssue?.Status || ""}
                                onChange={(value) => setEditingIssue({ ...editingIssue, Status: value })}
                                className="form-control"
                                style={{ width: "100%" }}
                                required
                                dropdownStyle={{ zIndex: 10001 }}
                                options={getOptionsByPath(NestedDatabucket, [USER_ISSUES, ISSUE_STATUS])}
                            />
                        </Col>
                        <Col span={8}>
                            <TimePickerField
                                label="Hours Spent"
                                name="HoursSpent"
                                format="HH:mm"
                                allowClear
                                value={editingIssue?.HoursSpent ? dayjs(editingIssue.HoursSpent, "HH:mm") : null}
                                onChange={(time, timeString) => setEditingIssue({ ...editingIssue, HoursSpent: timeString })}
                                style={{ width: "100%" }}
                            />
                        </Col>
                        <Col span={8}>
                            <SelectInput
                                label="Tech Stack"
                                value={editingIssue?.TechStack || ""}
                                onChange={(value) => setEditingIssue(prev => ({ ...prev, TechStack: value }))}
                                className="form-control"
                                style={{ width: "100%" }}
                                mode="multiple"
                                dropdownStyle={{ zIndex: 10001 }}
                                options={getOptionsByPath(NestedDatabucket, [USER_ISSUES, TECH_STACK])}
                            />
                        </Col>
                    </Row>
 
                    <div style={{ marginBottom: "10px" }}>
                        <TextareaField
                            label={<>Code Snippet{" "}{editingIssue?.Status === "Completed" && (<span style={{ color: "red" }}>*</span>)}</>}
                            value={editingIssue?.CodeSnippet || ""}
                            onChange={(e) => setEditingIssue({ ...editingIssue, CodeSnippet: e.target.value })}
                            rows="3"
                            style={{ width: "100%", padding: "8px", border: "1px solid #ccc", borderRadius: "4px" }}
                        />
                    </div>
 
                    <div style={{ marginBottom: "10px" }}>
                        <TextareaField
                            label={<>Remarks <span style={{ color: "red" }}>*</span></>}
                            value={editingIssue?.Remarks || ""}
                            onChange={(e) => setEditingIssue({ ...editingIssue, Remarks: e.target.value })}
                            autoSize={{ minRows: 2, maxRows: 10 }}
                            style={{ width: "100%", padding: "8px", border: "1px solid #ccc", borderRadius: "4px" }}
                        />
                    </div>
                </Card>
 
            </form>
        </div>
 
 
    );
};
 
export default UserTaskEdit